import { render } from "./BoardDataCountIcon.vue?vue&type=template&id=19b815e3&scoped=true"
import script from "./BoardDataCountIcon.vue?vue&type=script&lang=js"
export * from "./BoardDataCountIcon.vue?vue&type=script&lang=js"

import "./BoardDataCountIcon.vue?vue&type=style&index=0&id=19b815e3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b815e3"],['__file',"src/components/h5/board/BoardDataCountIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19b815e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19b815e3', __exports__)) {
    api.reload('19b815e3', __exports__)
  }
  
  module.hot.accept("./BoardDataCountIcon.vue?vue&type=template&id=19b815e3&scoped=true", () => {
    api.rerender('19b815e3', render)
  })

}


export default __exports__